import React, {useContext} from 'react';
import Page from '../../components/Page';
import Portfolio from '../../components/Portfolio';
import ViewBanner from "../../components/ViewBanner";
import PageContext from "../../contexts/Page";
import "./PortfolioView.scss";

const PortfolioView = () => {

	const {pageData} = useContext(PageContext);

	return (
		<Page>
            <ViewBanner title={pageData.tytul}/>
			<Portfolio/>
		</Page>
	);
};


export default PortfolioView;